import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import CardWithShadow from '@components/CardWithShadow/CardWithShadow';
import Loadable from '@components/Loadable/Loadable';
import { IMedicationResponseDetails } from '@interfaces/medications';
import { TSupplementResponseStatus } from '@interfaces/supplements';

import MedicationNeedsInfo from './MedicationNeedsInfo/MedicationNeedsInfo';
import MedicationResponseDetails from './MedicationResponseDetails/MedicationResponseDetails';

export interface IProps {
  className?: string;
  data: IMedicationResponseDetails | null;
  isLoading: boolean;
  error: boolean;
  hasUnseenResponses: boolean;
  isLastOneThatNeedsInfo: boolean;
  onSubmitNeedsInfoForm: (values: any) => void;
  onClose: () => void;
  onRetry: () => void;
}

const MedicationResponseDetailAside: FC<IProps> = ({
  className,
  data,
  isLoading,
  error,
  hasUnseenResponses,
  isLastOneThatNeedsInfo,
  onSubmitNeedsInfoForm,
  onClose,
  onRetry,
}) => {
  const { t } = useTranslation();

  const medicationNeedsInfo =
    data?.supplementInquiryStatusId === TSupplementResponseStatus.NeedsInfo;

  return (
    <CardWithShadow className={cn('supplement-response-details', className)}>
      <Loadable
        isLoading={isLoading}
        error={error && t('errors.medicationResponseDetailsError')}
        onRetry={onRetry}
      >
        {medicationNeedsInfo ? (
          <MedicationNeedsInfo
            hasUnseenResponses={hasUnseenResponses}
            isLastOneThatNeedsInfo={isLastOneThatNeedsInfo}
            onSubmit={onSubmitNeedsInfoForm}
            onClose={onClose}
            onRetry={onRetry}
          />
        ) : (
          data && <MedicationResponseDetails data={data} />
        )}
      </Loadable>
    </CardWithShadow>
  );
};

export default MedicationResponseDetailAside;
